export var RenderTargetFormat;
(function (RenderTargetFormat) {
    RenderTargetFormat[RenderTargetFormat["None"] = -1] = "None";
    RenderTargetFormat[RenderTargetFormat["R8G8B8"] = 0] = "R8G8B8";
    RenderTargetFormat[RenderTargetFormat["R8G8B8A8"] = 1] = "R8G8B8A8";
    RenderTargetFormat[RenderTargetFormat["R16G16B16A16"] = 17] = "R16G16B16A16";
    RenderTargetFormat[RenderTargetFormat["R32G32B32"] = 30] = "R32G32B32";
    RenderTargetFormat[RenderTargetFormat["R32G32B32A32"] = 15] = "R32G32B32A32";
    RenderTargetFormat[RenderTargetFormat["R16G16B16"] = 31] = "R16G16B16";
    RenderTargetFormat[RenderTargetFormat["DEPTH_16"] = 35] = "DEPTH_16";
    RenderTargetFormat[RenderTargetFormat["STENCIL_8"] = 36] = "STENCIL_8";
    RenderTargetFormat[RenderTargetFormat["DEPTHSTENCIL_24_8"] = 37] = "DEPTHSTENCIL_24_8";
    RenderTargetFormat[RenderTargetFormat["DEPTH_32"] = 38] = "DEPTH_32";
    RenderTargetFormat[RenderTargetFormat["DEPTHSTENCIL_24_Plus"] = 39] = "DEPTHSTENCIL_24_Plus";
})(RenderTargetFormat || (RenderTargetFormat = {}));
